
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"30","viewBox":"0 0 24 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.4375 11.25H19.5V7.5C19.5 3.36375 16.1362 0 12 0C7.86375 0 4.5 3.36375 4.5 7.5V11.25H3.5625C2.0125 11.25 0.75 12.5112 0.75 14.0625V27.1875C0.75 28.7388 2.0125 30 3.5625 30H20.4375C21.9875 30 23.25 28.7388 23.25 27.1875V14.0625C23.25 12.5112 21.9875 11.25 20.4375 11.25ZM7 7.5C7 4.7425 9.2425 2.5 12 2.5C14.7575 2.5 17 4.7425 17 7.5V11.25H7V7.5ZM13.25 20.9025V23.75C13.25 24.44 12.6912 25 12 25C11.3088 25 10.75 24.44 10.75 23.75V20.9025C10.0063 20.4688 9.5 19.6712 9.5 18.75C9.5 17.3713 10.6213 16.25 12 16.25C13.3787 16.25 14.5 17.3713 14.5 18.75C14.5 19.6712 13.9937 20.4688 13.25 20.9025Z","fill":"#FF3D53"}})])
          )
        }
      }
    